import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { fetchAiInsights, type AiInsight } from '../lib/api';
import { formatDateTime } from '../lib/format';

function AiInsightCard() {
  const [insight, setInsight] = useState<AiInsight | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      const result = await fetchAiInsights();
      if (!cancelled) {
        setInsight(result.ok && result.data ? result.data : null);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="rounded-xl border border-zt-border bg-zt-surface p-6">
      <div className="mb-3 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Sparkles className="text-zt-primary" size={18} />
          <h3 className="font-semibold text-white">AI insight</h3>
        </div>
        <Link to="/ai" className="text-xs text-zt-primary hover:underline">
          Open AI Console
        </Link>
      </div>

      {loading ? (
        <div className="space-y-2">
          <div className="h-3 w-full animate-pulse rounded bg-zt-border" />
          <div className="h-3 w-5/6 animate-pulse rounded bg-zt-border" />
          <div className="h-3 w-4/6 animate-pulse rounded bg-zt-border" />
        </div>
      ) : !insight?.configured ? (
        <p className="text-sm text-zt-muted">
          {insight?.message ?? 'AI provider is not configured. Add AI_API_KEY to enable insights.'}
        </p>
      ) : insight.content ? (
        <>
          <p className="whitespace-pre-wrap text-sm leading-relaxed text-slate-200">{insight.content}</p>
          {insight.generatedAt && (
            <p className="mt-3 text-xs text-zt-muted">
              Generated {formatDateTime(insight.generatedAt)}
              {insight.model ? ` · ${insight.model}` : ''}
            </p>
          )}
        </>
      ) : (
        <p className="text-sm text-zt-muted">
          {insight.message ?? 'Could not generate an insight right now.'}
        </p>
      )}
    </div>
  );
}

export default AiInsightCard;
